import { useEffect, useMemo, useState } from "react";
import { api } from "../lib/api";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { CardMini } from "../components/AffiliateBlocks";

export default function CreditCardsPage() {
  const [all, setAll] = useState([]);
  const [q, setQ] = useState("");
  const [issuer, setIssuer] = useState("");
  const [lounge, setLounge] = useState(false);
  const [maxFee, setMaxFee] = useState("");

  useEffect(() => { api.get("/cards?active_only=true&limit=100").then((r) => setAll(r.data.items)); }, []);

  const filtered = useMemo(() => {
    return all.filter((c) => {
      if (issuer && c.issuer !== issuer) return false;
      if (lounge && !c.lounge_access) return false;
      if (maxFee && c.annual_fee > Number(maxFee)) return false;
      if (q && !(c.card_name.toLowerCase().includes(q.toLowerCase()) || c.issuer.toLowerCase().includes(q.toLowerCase()))) return false;
      return true;
    });
  }, [all, q, issuer, lounge, maxFee]);

  const issuers = [...new Set(all.map((c) => c.issuer))];

  return (
    <div className="min-h-screen bg-[#F9F9F6]">
      <Header />
      <div className="container-page py-12 md:py-20">
        <div className="overline text-[#B4533C]">Credit Cards</div>
        <h1 className="font-serif text-5xl md:text-6xl tracking-tight mt-2">The shortlist</h1>
        <p className="mt-4 text-[#4A4742] max-w-2xl">Editor-rated travel and rewards cards. Filter by issuer, fee, and benefits.</p>
      </div>
      <div className="container-page pb-8">
        <div className="border border-[#D6CFC4] bg-white p-5 grid md:grid-cols-4 gap-3">
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search cards…" className="border border-[#D6CFC4] px-3 py-2 text-sm" data-testid="card-search-input" />
          <select value={issuer} onChange={(e) => setIssuer(e.target.value)} className="border border-[#D6CFC4] px-3 py-2 text-sm" data-testid="card-issuer-filter">
            <option value="">All issuers</option>
            {issuers.map((i) => <option key={i} value={i}>{i}</option>)}
          </select>
          <input type="number" placeholder="Max annual fee $" value={maxFee} onChange={(e) => setMaxFee(e.target.value)} className="border border-[#D6CFC4] px-3 py-2 text-sm" data-testid="card-maxfee-filter" />
          <label className="flex items-center gap-2 text-sm" data-testid="card-lounge-filter">
            <input type="checkbox" checked={lounge} onChange={(e) => setLounge(e.target.checked)} /> Lounge access only
          </label>
        </div>
      </div>
      <div className="container-page pb-20 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
        {filtered.map((c) => <CardMini key={c.id} card={c} />)}
      </div>
      <Footer />
    </div>
  );
}
